<template>

    <div class="">
        <div v-if="trialXPNiceDate">
            <p class="text-center small mb-0">Your account's trial period expires on: <strong class="text-red">{{trialXPNiceDate}}</strong></p>
            <p class="text-center small mt-0">To continue your subscription you need to activate your account and confirm your subscription.</p>
        </div>

        <div v-else>
            <p class="text-center small">Your account verified and active since <strong>{{userCompany.attributes.verifiedOn}}</strong></p>
        </div>

        <pricing-table class="mb-3" @level="setActiveLevel" @count="setActiveCardCount"></pricing-table>

        <p class="text-center small my-0">Based on your current usage, your account is tier T{{activeLevel.tier}} and your estimated bill will be <span class="text-primary">{{ {currency: 'EUR', amount:billableEstimate } | currency }}</span></p>
        <p class="text-center small mt-0">Your account will be billed at the next billing cycle, on {{nextBillingDate}}.</p>



        <div v-if="trialXPNiceDate">
            <div class="my-3 text-center">
                <checkbox-field v-model="confirm" color="secondary">I have read and agree to the <a href="/terms-regular" target="_blank">subscription terms</a></checkbox-field>
            </div>

            <div class="row justify-content-center mb-3">
                <div class="col-6">
                    <button-field color="secondary"
                                  type="submit"
                                  block
                                  @click="confirmSubscription"
                                  icon="check"
                                  :disabled="!confirm"
                    >
                        {{$ml.get('CONFIRM_SUBSCRIPTION')}}
                    </button-field>
                </div>
                <div class="col-12 pt-4">
                    <hr/>
                    <p class="text-center small mb-0">Need a formal contract? Request it by <a href="#" @click="openSubscribe">following this link</a> and filling out the form.</p>
                </div>
            </div>

        </div>

        <div v-else>
            <div class="row justify-content-center mb-3">
                <div class="col-6">
                    <button-field color="dark"
                                  type="submit"
                                  block
                                  @click="cancelSubscription"
                                  icon="times"
                    >
                        {{$ml.get('CANCEL_SUBSCRIPTION')}}
                    </button-field>
                </div>
                <div class="col-12 pt-4">
                    <hr/>
                    <p class="small mb-0 text-center w-100">Need to find an invoice? Check your <a href="#" @click="openSubscribe">billing details</a> page.</p>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import PricingTable from "@/components/global/PricingTable.vue";
import Parse from "parse";
import moment from "moment/moment";

export default {
    name: "ActivateSubscription",
    components: {PricingTable},
    data() {
        return {
            tiers: [],
            activeLevel: {},
            confirm: false,
            loading: false,
            activeCardCount: 0,
            level: {},
        }
    },
    computed: {
        userCompany(){
            return this.$store.state.userCompany;
        },
        nextBillingDate() {
            const today = moment();
            const thirdOfThisMonth = moment().startOf('month').add(2, 'days'); // 3rd of current month

            if (today.isBefore(thirdOfThisMonth)) {
                // If today's date is before the 3rd of the current month
                return thirdOfThisMonth.format('D/M/YYYY');
            } else {
                // If today's date is on or after the 3rd of the current month
                const thirdOfNextMonth = thirdOfThisMonth.add(1, 'month');
                return thirdOfNextMonth.format('D/M/YYYY');
            }
        },
        billableEstimate(){
            return this.activeCardCount && this.activeLevel ? this.activeCardCount * this.activeLevel.price : 1.00;
        },

        currentCardCount(){
            if(this.$store.state.userCompany) {
                return this.$store.state.userCompany.attributes.cardCount ? this.$store.state.userCompany.attributes.cardCount : 0;
            } else {
                return 0;
            }
        },

        trialXPNiceDate() {
            let curUser = Parse.User.current();
            let userTrial = curUser && curUser.attributes.trialUntil ? moment(curUser.attributes.trialUntil) : null;
            let companyTrial = this.userCompany && this.userCompany.attributes.trialUntil ? moment(this.userCompany.attributes.trialUntil) : null;
            let maxTrial = null;

            // Check if both dates are valid
            if (userTrial && userTrial.isValid() && companyTrial && companyTrial.isValid()) {
                maxTrial = moment.max(userTrial, companyTrial);
            } else if (userTrial && userTrial.isValid()) {
                // Only user trial date is valid
                maxTrial = userTrial;
            } else if (companyTrial && companyTrial.isValid()) {
                // Only company trial date is valid
                maxTrial = companyTrial;
            }

            return maxTrial ? maxTrial.format('D/MM/Y') : false;
        },

    },
    methods: {
        cancelSubscription(){
            this.$store.commit('setGlobalLoader', true);

            this.$store.dispatch('cancelSubscription').then(()=>{
                this.$store.commit('setGlobalLoader', false);
            });
        },
        openSubscribe(){

            let ulr_base = 'https://www.qfecard.com/confirm-registration/';
            let curUser = Parse.User.current();
            let compData = this.$store.state.userCompany ? this.$store.state.userCompany.attributes : {atrributes: {}};

            if(curUser){
                let params = {
                    email: curUser.attributes.email,
                    firstName: curUser.attributes.firstName,
                    lastName: curUser.attributes.lastName,
                    company: compData.name,
                    phone: compData.telephone,
                    address: compData.billingAddress,
                    billingEmail: compData.billingEmail,
                    vat: compData.vatNumber,
                    responsible: compData.responsible,
                    website: compData.website,
                    companyId: this.$store.state.userCompany.id,
                }

                if(compData.usedPromo && compData.usedPromo.get('code')){
                    params.promo = compData.usedPromo.attributes.code;
                }

                let paramsString = JSON.stringify(params);
                let encodedParams = btoa(paramsString);

                let url = ulr_base +'?data='+ encodedParams;

                window.open(url, '_blank');
            }


        },
        setActiveCardCount(count){
            this.activeCardCount = count;
        },
        setActiveLevel(level){
            this.activeLevel = level;
        },
        confirmSubscription(){
            let self = this;
            this.$store.commit('setGlobalLoader', true);

            this.$store.dispatch('confirmSubscription').then(()=>{
                this.$store.commit('setGlobalLoader', false);
                this.$notify({
                    group: 'notification',
                    type: 'success',
                    text: this.$ml.get('notification_subscribe_success')
                });

                if(this.$route.name === 'suspended'){
                    setTimeout(()=>{
                        self.$router.push({name: 'home'});
                        //debugger;
                    }, 3000);
                }


            }).catch(err=>{
                console.log("Subscription error:", err);

                this.$notify({
                    group: 'notification',
                    type: 'error',
                    text: this.$ml.get('notification_subscribe_success')
                });

                this.$store.commit('setGlobalLoader', false);
            });
        },
    }

}

</script>

<style scoped>

</style>
